import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormControlErrorCodeModule } from '@portal-core/forms/components/form-control-error-code/form-control-error-code.module';
import { GridHeaderFilterModule } from '@portal-core/ui/grid/components/grid-header-filter/grid-header-filter.module';
import { GridHeaderFilterFormModule } from '@portal-core/ui/grid/directives/grid-header-filter-form/grid-header-filter-form.module';
import { GridHeaderFilterMenuModule } from '@portal-core/ui/grid/directives/grid-header-filter-menu/grid-header-filter-menu.module';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { GridNumberFilterComponent } from './grid-number-filter.component';

@NgModule({
  imports: [
    McColorModule,
    CommonModule,
    FormsModule,
    FormControlErrorCodeModule,
    GridHeaderFilterFormModule,
    GridHeaderFilterMenuModule,
    GridHeaderFilterModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule
  ],
  declarations: [
    GridNumberFilterComponent
  ],
  exports: [
    GridNumberFilterComponent
  ]
})
export class GridNumberFilterModule { }
